module.exports = __webpack_public_path__ + "static/img/card3.45064036.png";